import { omit } from "lodash";
import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Form } from "semantic-ui-react";

import FormikAPIErrorMessage from "./FormikAPIErrorMessage.jsx";

import { getErrorStateFromProps } from "../formUtils.js";

class FormikSemanticTextArea extends PureComponent {
  static propTypes = {
    field: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    apiErrors: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string
  };

  render() {
    const {
      field: { name, value },
      form: { setFieldValue, setFieldTouched },
      label,
      type,
      required,
      readOnly,
      disabled,
      apiErrors
    } = this.props;

    // set semantic-ui field error state
    const isError = getErrorStateFromProps(this.props);

    // needed to adjust field margin-bottom if error is shown
    const className = isError ? "errored" : null;

    const isRequired = readOnly || disabled ? false : required;

    const inputProps = {
      ...omit(this.props, "field", "form", "apiErrors"),
      ...this.props.field,
      required: isRequired,
      type: type ? type : "text",
      className: className,
      error: isError
    };

    if (!readOnly) {
      return (
        <Fragment>
          <Form.TextArea
            {...inputProps}
            onChange={(e, { name, value: changeValue }) => {
              setFieldValue("ignoreChangeInSideEffect", false);
              setFieldValue(name, changeValue);
            }}
            onBlur={evt => {
              setFieldValue("ignoreChangeInSideEffect", false);
              setFieldTouched(name, true);
            }}
          />
          <FormikAPIErrorMessage name={name} apiErrors={apiErrors} />
        </Fragment>
      );
    }

    return (
      <Form.Field className={className}>
        {label && <label htmlFor={name}>{label || null}</label>}
        <p>{value || "-"}</p>
      </Form.Field>
    );
  }
}

export default FormikSemanticTextArea;
